module.exports = __webpack_public_path__ + "img/bg_fountain_square.40f92f67.jpg";